<template>
	<div class="upload-container">
		<!-- 关闭按钮 -->
		<div class="close-btn" @click="handleClose">
			<i class="el-icon-close"></i>
		</div>

		<!-- 上传文件列表 -->
		<div class="download-list" v-if="displayFiles.length > 0">
			<div class="list-title">查看{{Stype}}：</div>
			<div class="ckcontent" v-if="Szlcontent!==''">
				{{Szlcontent}}
			</div>

			<div v-for="(file, index) in displayFiles" :key="index" class="file-item">
				<a :href="file.url" :download="file.name" class="file-link" target="_blank">
					<i class="el-icon-document"></i>
					<span>{{ formatFileName(file.name) }}</span>
				</a>

			</div>
		</div>

		<div v-else class="empty-tip">
			<i class="el-icon-document"></i>
			<p>暂无文件</p>
		</div>

		<!-- 关闭按钮 -->
		<div class="confirm-btn-container">
			<el-button type="primary" @click="handleClose">
				关闭
			</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Gckfiles',
		props: {
			upfiles: {
				type: Array,
				default: () => []
			},
			Stype: {
				type: String,
				default: ''
			},
			Szlcontent: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				displayFiles: [] // 显示的文件列表
			};
		},
		methods: {
			// 格式化文件名（显示省略号）
			formatFileName(name) {
				const maxLength = 20; // 最大显示长度
				if (name && name.length > maxLength) {
					return name.substring(0, maxLength) + '...';
				}
				return name;
			},


			// 关闭按钮点击事件
			handleClose() {
				// 关闭时将当前的文件列表传回父组件
				this.$emit('close', [...this.displayFiles]);
			}

		},
		watch: {
			// 监听父组件传入的文件列表变化
			upfiles: {
				immediate: true,
				handler(newFiles) {
					this.displayFiles = [...newFiles];
				}
			}
		}
	};
</script>

<style scoped>
	.upload-container {
		width: 30vw;
		min-height: 20vh;
		background-color: white;
		padding: 20px;
		box-sizing: border-box;
		border: 1px solid #f0f0f0;
		border-radius: 4px;
		position: relative;
	}

	.close-btn {
		position: absolute;
		top: 10px;
		right: 10px;
		cursor: pointer;
		font-size: 18px;
		color: #999;
		z-index: 1;
	}

	.close-btn:hover {
		color: #666;
	}

	.download-list {
		margin-top: 15px;
		margin-bottom: 15px;
		max-height: 300px;
		overflow-y: auto;
	}

	.list-title {
		font-size: 14px;
		color: #333;
		margin-bottom: 8px;
		font-weight: 500;
		text-align: left;
	}

	.file-item {
		margin-bottom: 6px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 4px 6px;
		border-radius: 3px;
		transition: background-color 0.2s;
	}

	.file-item:hover {
		background-color: #f5f7fa;
	}

	.file-link {
		display: inline-flex;
		align-items: center;
		color: #409eff;
		text-decoration: none;
		font-size: 13px;
		max-width: calc(100% - 40px);
	}

	.file-link:hover {
		color: #1890ff;
	}

	.file-link i {
		font-size: 14px;
		margin: 0 5px;
	}

	.delete-btn {
		color: #f56c6c;
		padding: 0 5px;
		margin-left: 5px;
	}

	.delete-btn:hover {
		color: #e4393c;
		background-color: rgba(245, 108, 108, 0.1);
	}

	.confirm-btn-container {
		display: flex;
		justify-content: center;
		margin-top: 15px;
	}

	.empty-tip {
		text-align: center;
		color: #999;
		padding: 40px 0;
	}

	.empty-tip i {
		font-size: 48px;
		margin-bottom: 10px;
	}

	.empty-tip p {
		margin: 0;
		font-size: 14px;
	}

	.ckcontent {
		width: 95%;
		margin: 20px auto;
		max-height: 10vh;
		border-radius: 5px;
		padding: 5px !important;
		font-size: 12px !important;
		color: #333 !important;
		line-height: 25px;
		border: 1px solid #d0d0d0;
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;
		text-align: left;
	}
</style>